
(function () {
  'use strict';

  new Vue({
    el: '[data-vue=reduceText]',
    data: {
      showText: false,
      minDivHeight: 350,
      maxDivHeight: null
    },
    methods: {
      textReduce () {
        this.showText = !this.showText
        const heightDiv = document.querySelector('.page-lottery-como-apostar__intro__text-reduce')

        if (this.showText == true) {
          heightDiv.style.height = `${this.maxDivHeight}px`
          heightDiv.style.transition = 'height 0.5s ease-in-out'
          heightDiv.style.overflow = 'block'
          window.scrollTo({ top: 300, behavior: 'smooth' })
        }
        if (this.showText && window.innerWidth < 992) {
          window.scrollTo({ top: 200, behavior: 'smooth' })
        }
        if (!this.showText) {
          heightDiv.style.height = `${this.minDivHeight}px`
          heightDiv.style.transition = 'height 0.5s ease-in-out'
          heightDiv.style.overflow = 'hidden'
        }
      }
    },
    mounted () {
      const heightDiv = document.querySelector('.page-lottery-como-apostar__intro__text-reduce')
      heightDiv.style.height = `${this.minDivHeight}px`
      heightDiv.style.overflow = 'hidden'
    },
    created () {
      const divHeight = document.querySelector('.page-lottery-como-apostar__intro__text-reduce').offsetHeight
      this.maxDivHeight = divHeight + 24
      if (this.showText && window.innerWidth < 992) {
        this.maxDivHeight = divHeight + 40
      }
    }
  });
})();
